import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    button: {
      width: '100%',
      zIndex: 12,
    },
    buttonSocialSlack: {
      width: '100%',
      zIndex: 12,
    },
    buttonSocialMs: {
      width: '70%',
      zIndex: 12,
    },
    linkSocial: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: '-10px',
      width: '100%',
    },
    buttonText: {
      fontSize: '0.7em',
      fontWeight: 'bold',
      fontFamily: 'Montserrat',
    },
    card: {
      display: 'flex',
      flexDirection: 'row',
      height: '100%',
      maxHeight: '70px',
      justifyContent: 'center',
      margin: '5px 1vw',
      minWidth: '200px',
      padding: '1vh 3px',
      zIndex: 10,
      [theme.breakpoints.down('768')]: {
        margin: '0 2vw',
        minWidth: '220px',
      },
    },
    cardActions: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    cardArea: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      textAlign: 'center',
      width: '70%',
    },
    cardContent: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      padding: '0 !important',
      width: '60%',
    },
    cardMedia: {
      alignItems: 'center',
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
      width: '40%',
    },
    image: {
      alignSelf: 'center',
      borderRadius: '5px',
      height: '2vw',
      minHeight: 40,
      minWidth: 40,
      width: '2vw',
    },
    platformLogo: {
      backgroundColor: 'white',
      borderRadius: '50%',
      height: '15px',
      margin: '0 0 -30px -8px',
      padding: '3px',
      width: '15px',
    },
    teamName: {
      display: 'flex',
      height: '100%',
      fontSize: '1em',
      fontFamily: 'Montserrat',
      fontWeight: 600,
      textAlign: 'center',
    },
  })
);
